var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.96 41.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.23,
    cy: 12.98,
    r: 4.18,
    transform: "translate(-3.91 6.52) rotate(-22.76)",
    fill: "#00c880",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.42,11.42c0,.66-.53,1.19-1.19,1.19s-1.19-.53-1.19-1.19.53-1.19,1.19-1.19,1.19.53,1.19,1.19Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.23,12.61h0c-1.22,0-2.21.99-2.21,2.21h0c0,.32.26.58.58.58h3.26c.32,0,.58-.26.58-.58h0c0-1.22-.99-2.21-2.21-2.21Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.4,
    cy: 11.28,
    r: 3.19,
    fill: "#ffba00",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.31,10.09c0,.5-.41.91-.91.91s-.91-.41-.91-.91.41-.91.91-.91.91.41.91.91Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.4,11h0c-.93,0-1.68.75-1.68,1.68h0c0,.24.2.44.44.44h2.49c.24,0,.44-.2.44-.44h0c0-.93-.75-1.68-1.68-1.68Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.06,
    y: 18.4,
    width: 8.33,
    height: 2.03,
    rx: 1.01,
    ry: 1.01,
    fill: "#00c880",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.06,
    y: 21.49,
    width: 5.24,
    height: 2.03,
    rx: 1.01,
    ry: 1.01,
    fill: "#1696e5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.69,
    y: 26.76,
    width: 8.33,
    height: 2.03,
    rx: 1.01,
    ry: 1.01,
    fill: "#1696e5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.69,
    y: 29.84,
    width: 5.24,
    height: 2.03,
    rx: 1.01,
    ry: 1.01,
    fill: "#1696e5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.22,
    y: 14.98,
    width: 6.38,
    height: 1.55,
    rx: 0.78,
    ry: 0.78,
    fill: "#ffba00",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.22,
    y: 17.34,
    width: 4.01,
    height: 1.55,
    rx: 0.78,
    ry: 0.78,
    fill: "#1696e5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.96,6.4v6.26c0,.59-.48,1.07-1.07,1.07h-1.75V5.34h1.75c.59,0,1.07.47,1.07,1.06Z",
    fill: "#00c880",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.96,17.73v6.26c0,.59-.48,1.07-1.07,1.07h-1.75v-8.39h1.75c.59,0,1.07.48,1.07,1.06Z",
    fill: "#ffba00",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.96,29.07v6.26c0,.58-.48,1.06-1.07,1.06h-1.75v-8.39h1.75c.59,0,1.07.48,1.07,1.07Z",
    fill: "#1696e5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.58,0H3.71C2.18,0,.93,1.24.93,2.77v3.89h-.43c-.27,0-.5.22-.5.5s.23.5.5.5h.43v4.48h-.43C.23,12.14,0,12.36,0,12.64s.22.5.5.5h.43v4.48h-.43c-.28,0-.5.22-.5.5s.22.5.5.5h.43v4.48h-.43c-.28,0-.5.22-.5.5s.22.5.5.5h.43v4.48h-.43c-.28,0-.5.22-.5.5s.22.5.5.5h.43v4.48h-.43c-.27,0-.5.23-.5.5s.23.5.5.5h.43v3.88c0,1.54,1.25,2.78,2.78,2.78h35.66c1.53,0,2.77-1.24,2.77-2.78V2.56c0-1.41-1.15-2.56-2.56-2.56Zm1.56,38.95c0,.98-.79,1.78-1.77,1.78H3.71c-.98,0-1.78-.8-1.78-1.78v-3.88h.43c.28,0,.5-.22.5-.5s-.22-.5-.5-.5h-.43v-4.48h.43c.28,0,.5-.22.5-.5s-.22-.5-.5-.5h-.43v-4.48h.43c.28,0,.5-.22.5-.5s-.22-.5-.5-.5h-.43v-4.48h.43c.28,0,.5-.22.5-.5s-.22-.5-.5-.5h-.43v-4.48h.43c.28,0,.5-.22.5-.5s-.22-.5-.5-.5h-.43v-4.48h.43c.28,0,.5-.23.5-.5s-.22-.5-.5-.5h-.43v-3.89c0-.97.8-1.77,1.78-1.77h35.87c.86,0,1.56.7,1.56,1.56v36.39Z",
    fill: "#192c62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.59,3.52C12.03,3.52,4.24,11.3,4.24,20.86c0,3.81,1.25,7.32,3.34,10.19.02.04.03.08.05.11.02.03.06.05.09.07,3.17,4.22,8.2,6.97,13.87,6.97,9.56,0,17.35-7.78,17.35-17.35S31.16,3.52,21.59,3.52Zm16.32,16.85h-15.82V4.54c8.61.26,15.56,7.21,15.82,15.82ZM21.09,4.54v16.07l-12.93,9.55c-1.83-2.64-2.92-5.84-2.92-9.3,0-8.84,7.07-16.05,15.85-16.32Zm.5,32.67c-5.2,0-9.83-2.45-12.83-6.25l12.99-9.6h16.16c-.27,8.78-7.48,15.85-16.32,15.85Z",
    fill: "#192c62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.97,
    cy: 29.01,
    r: 4.53,
    fill: "#1696e5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.37,27.38c0,.61-.49,1.1-1.1,1.1s-1.1-.49-1.1-1.1.49-1.1,1.1-1.1,1.1.49,1.1,1.1Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.27,28.48h0c-1.13,0-2.05.92-2.05,2.05h0c0,.3.24.54.54.54h3.02c.3,0,.54-.24.54-.54h0c0-1.13-.92-2.05-2.05-2.05Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.87,27.75c0,.55-.45.99-.99.99-.16-.15-.34-.27-.54-.37.24-.26.39-.61.39-1,0-.21-.04-.41-.12-.58.09-.03.18-.04.27-.04.55,0,.99.45.99.99Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.72,30.58c0,.27-.21.48-.48.48h-.74c.12-.15.18-.33.18-.54,0-.71-.31-1.34-.8-1.79.51,0,.97.21,1.3.54.33.33.54.79.54,1.3Z",
    fill: "#fff",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSms);
export default __webpack_public_path__ + "static/media/icon-sms.c04fa66539ea8bb5ee5587af5f9d433d.svg";
export { ForwardRef as ReactComponent };